import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';

import RadioItem from '../RadioItem';
import s from './styles.module.scss';

const DraftScopeRadioOption = ({
  value,
  selected,
  disabled = false,
  title,
  description,
  testId,
  onSelect,
  children = null,
}) => {
  const isSelected = selected === value;

  const handleSelect = () => {
    if (disabled) return;
    onSelect(value);
  };

  return (
    <div
      className={cn(s.option, {
        [s.optionSelected]: isSelected,
        [s.optionDisabled]: disabled,
      })}
    >
      <div
        className={s.optionRow}
        data-testid={testId}
        aria-disabled={disabled || undefined}
        onClick={handleSelect}
      >
        <RadioItem
          value={value}
          checkedValue={selected}
          disabled={disabled}
          onChange={onSelect}
        />
        <div className={s.optionCopy}>
          <div className={s.optionTitle}>{title}</div>
          <If condition={Boolean(description)}>
            <div className={s.optionDescription}>{description}</div>
          </If>
        </div>
      </div>
      <If condition={Boolean(children)}>
        {children}
      </If>
    </div>
  );
};

DraftScopeRadioOption.propTypes = {
  value: PropTypes.string.isRequired,
  selected: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  testId: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default DraftScopeRadioOption;
